// extracted by mini-css-extract-plugin
export default {"desktop":"style_desktop__qJPmJ","mobile":"style_mobile__xr1d+","laptop":"style_laptop__MLVO6","v3":"style_v3__NFH8v"};